import { useConnectAppSendAction } from './actions/useConnectAppSendAction'
import { useAgentQuestionAction } from './actions/useAgentQuestionAction'
import { useExchangeVersionActions } from './actions/useExchangeVersionActions'
import { useMainAskBarPrefillAction } from './actions/useMainAskBarPrefillAction'
import { useRegenerateAssistantAction } from './actions/useRegenerateAssistantAction'
import { useSendEditVersionAction } from './actions/useSendEditVersionAction'
import { useSendMessageAction } from './actions/useSendMessageAction'

/** @param {object} m */
export function useAppShellChatSendActions(m) {
  const versions = useExchangeVersionActions(m)
  const { handleSendMessage } = useSendMessageAction(m)
  const { handleSendEditVersion } = useSendEditVersionAction(m, versions)
  const { handleRegenerateAssistantVersion } = useRegenerateAssistantAction(m, versions)
  const prefill = useMainAskBarPrefillAction(m)
  const connect = useConnectAppSendAction({ handleSendMessage })
  const agentQuestion = useAgentQuestionAction(m, { handleSendMessage })
  return {
    versions,
    handleSendMessage,
    handleSendEditVersion,
    handleRegenerateAssistantVersion,
    prefill,
    connect,
    agentQuestion,
  }
}
